module.exports = __webpack_public_path__ + "img/768_top.d1d7736.jpg";